import { useQuery } from '@tanstack/react-query';

import { getTreatmentPeriodMassagers } from '@/services/main/consent/treatmentPeriod';
import { useClinicContext } from './useClinicContext';
import { useClinicPortalServiceType } from './clinicPortalServiceType';

/**
 * Massager dropdown for 加療期間切れリスト search form.
 * RA2 equivalent: /rezepts/search_massagers?karyoflg=1 — RA2 refetches on
 * date change AND on radio switch to 指定あり.
 *
 * Fires whenever tenant is ready (from/to may be empty — BE returns the
 * full list scoped by clinic + service type in that case). The query key
 * includes from/to so React Query refetches when either changes.
 */
export const useConsentTreatmentPeriodMassagers = (
  from: string | undefined,
  to: string | undefined,
) => {
  const { tenant, clinicNumber } = useClinicContext();
  const serviceType = useClinicPortalServiceType();

  return useQuery({
    queryKey: ['consent-treatment-period', 'massagers', tenant, clinicNumber, serviceType, from, to],
    queryFn: () => getTreatmentPeriodMassagers(tenant ?? '', clinicNumber ?? '', serviceType, {
      search_treatement_from: from,
      search_treatement_to: to,
    }),
    enabled: !!tenant && !!clinicNumber,
    staleTime: 60_000,
  });
};

export default useConsentTreatmentPeriodMassagers;
